import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Button, TextField, Autocomplete, Alert } from '@mui/material';
import { Sheet, ActionBar } from '../../components';

export default function VendorPicker({ vendors, loadVendors, fetchResource, isPending, value, onChange, error }) {
  const { t } = useTranslation();
  const [addVendorOpen, setAddVendorOpen] = useState(false);
  const [newVendorName, setNewVendorName] = useState('');
  const [addVendorError, setAddVendorError] = useState('');
  const [pendingVendorName, setPendingVendorName] = useState(null);

  const openAddVendor = () => { setAddVendorOpen(true); setNewVendorName(''); setAddVendorError(''); setPendingVendorName(null); };

  const selectVendorByName = (list, name) => {
    const added = (list.vendors || []).find(v => v.name.toLowerCase() === name.toLowerCase());
    if (!added) { setPendingVendorName(name); return setAddVendorError(t('calendar.invoice.vendorNotListed')); }
    onChange(added.id);
    setAddVendorOpen(false);
    setNewVendorName('');
    setAddVendorError('');
    setPendingVendorName(null);
  };

  const addVendor = async () => {
    if (pendingVendorName) {
      const list = await loadVendors('addVendor');
      if (list.error) return setAddVendorError(t('calendar.invoice.vendorReloadFailed'));
      return selectVendorByName(list, pendingVendorName);
    }
    const name = newVendorName.trim();
    if (!name) return;
    const r = await fetchResource({ resource: 'vendors/add', body: { vendor: name }, loadingKey: 'addVendor' });
    if (r.error) { await loadVendors(); return setAddVendorError(r.error); }
    const list = await loadVendors('addVendor');
    if (list.error) { setPendingVendorName(name); return setAddVendorError(t('calendar.invoice.vendorReloadFailed')); }
    selectVendorByName(list, name);
  };

  return (
    <>
      <Autocomplete options={vendors.map(v => v.name)}
        value={vendors.find(v => v.id === value)?.name || null}
        onChange={(e, name) => { const v = vendors.find(x => x.name === name); onChange(v?.id); }}
        renderInput={p => <TextField {...p} label={t('calendar.invoice.vendor')} error={error} />} />
      <Button onClick={openAddVendor}>{t('calendar.invoice.newVendor')}</Button>
      {addVendorOpen && (
        <Sheet open onClose={() => setAddVendorOpen(false)} title={t('calendar.invoice.newVendor')}
          actions={
            <ActionBar
              cancel={{ label: t('common.cancel'), onClick: () => setAddVendorOpen(false) }}
              confirm={{ label: t('calendar.invoice.addVendor'), onClick: addVendor, disabled: isPending('addVendor') || (!pendingVendorName && !newVendorName.trim()) }}
            />
          }>
          <Stack spacing={2}>
            {addVendorError && <Alert severity='warning'>{addVendorError}</Alert>}
            <TextField autoFocus disabled={Boolean(pendingVendorName)} label={t('calendar.invoice.newVendorName')} value={newVendorName} onChange={e => setNewVendorName(e.target.value)} />
          </Stack>
        </Sheet>
      )}
    </>
  );
}
